/**
 * Bai.Zhiming
 * 2018-7-26
 * 推头条稿件禁止编辑蒙层组件
 */
"use strict";
angular.module("pushHeadDisabledEditDirModule", [])
    .directive("pushHeadDisabledEdit", ["$compile", function($compile) {
        return {
            replace: false,
            scope: {
                isPushedHead: "="
            },
            restirct: "A",
            link: function(scope, $element, $attrs) {
                $element.css("position", "relative");
                var layer = $compile([
                    "<div ng-if='isPushedHead' style='cursor:not-allowed;top:0px;left:0px;z-index:1000;position:absolute;width:100%;height:100%;opacity:0.2;background:black'>",
                    "</div>",
                    "<p ng-if='isPushedHead' style='cursor:not-allowed;font-weight:bold;top:0px;left:0px;z-index:1000;position:absolute;width:100%;text-align:center;'>该稿件为推头条稿件，请去原频道的相应稿件中进行修改</p>"
                ].join(""))(scope);
                $element.append(layer);
            }
        };
    }]);